import React, { useState, useRef } from 'react';
import propTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Modal from '../../ui/Modal';
import Slider from "react-slick";
import GalleryOverlay from '../GalleryOverlay';
import { theme } from '../../../themes/default-theme';
import { Cta, RespImg } from '../../ui';
import { Grid, Box } from '@material-ui/core';
import Text from '../../typography';
import {chunk} from 'lodash';
import {useMediaQuery} from '@material-ui/core';

const Wrapper = styled.div`
  position: relative;
  max-width: 1600px;
  margin: 0 auto;

  .slick-dots {
    margin:20px 0 0 0;
    padding:0;
    text-align:center;
    list-style:none;
    li {
      display:inline-block;
      margin:5px 5px;
    }
  }
  h3 {
    margin-bottom:10px;
    max-width: 815px;
    margin-left: auto;
    margin-right: auto;
    ${props => props.backgroundColor === 'black' ? `
      color:${theme.palette.white};
    `
    : `
      color:${theme.palette.charcoal};
    `
  };
    ${theme.breakpoints.up("md")} {
      margin-bottom:15px;
    }
  }
  
  ${props => props.backgroundColor === 'grey' ? `
      background:${theme.palette.lightGrey};
    `
    : `
      background:${props.backgroundColor};
    `
  };
  ${theme.breakpoints.up('md')} {
    margin: 0 auto;
  }

`

const Container = styled.div`
  width: 100%;
  max-width: 1397px;
  margin: auto; 
  margin-top:30px;
  ${theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`

const ImageRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  
  ${theme.breakpoints.down("sm")} {
    // gap: 0;
    width:100%;
    margin-bottom: 8px;
    justify-content:center;
    padding: 0 11px;
  }
  h4 {
    position:absolute;
    right:0;
    bottom:0; 
    width: 100%;
    margin:0;
    padding:0;  
    z-index:3;
    text-align: center;

    > span {
      position: relative;
      padding: 8px;
      width: 100%;
      display: table;
      &:before {
        content: '';
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(rgba(0, 0, 0, -2) 0%, rgba(0, 0, 0, 0.3) 80%);
        width: 100%;
        height: calc(100% + 20px);
        z-index: -1;
        margin: auto;
      }
    }
  }

  ${props => props.layout == '3' && `
    flex-wrap: nowrap;
  `}

  ${props => props.layout == '6' && `
    width:32.8%;
  `}

  ${props => props.layout == '9' && `
    width:32.8%;
  `}
`

const SliderItem = styled.div`
 
        ${props => props.layout == '3' && `
            > div {

            }
        `}
        ${props => props.layout == '6' && `
            display: flex !important;
            flex-wrap: wrap;
            justify-content: space-between;
            > div {
              > div {
                width: calc(50% - 4px);
                ${theme.breakpoints.down("md")} {
                  width: calc(50% - 8px);
                }
              }
              &:first-child, &:nth-child(3) {
                > div {
                  width: 100%;
                  ${theme.breakpoints.down("md")} {
                    width: calc(100% - 8px);
                  }
                }
              }

            }
        `}
        ${props => props.layout == '9' && `
            display: flex !important;
            flex-wrap: wrap;
            justify-content: space-between;
            > div {
                > div {
                  width: calc(50% - 4px);
                  ${theme.breakpoints.down("md")} {
                    width: calc(50% - 8px);
                  }
                }

                &:first-child, &:last-child {
                  > div:first-child {
                    width: 100%;
                    ${theme.breakpoints.down("md")} {
                      width: calc(100% - 8px);
                    }
                  }
                }

                &:nth-child(2) {
                  > div:last-child {
                    width: 100% !important;
                  }
                }

    
            }
        `}
 
  ${theme.breakpoints.down("sm")} {

  }
`

const ImageContainer = styled.div`
  position: relative; 
  transition: all 300ms ease;
  text-decoration:none;
  overflow: hidden;
  border-radius: 22px;
 
  h4 {
    font-size:15px;
  }

  // &:hover {
  //   transform: scale(1.02);
  // }
`

const CTAContainer = styled.div`
  margin-top:35px;
  text-align:center;
  ${theme.breakpoints.down("sm")} {
    margin-top:25px;
  }
  a {
    display:inline-block;
    width:auto;
    margin:auto;
  }
`

const SliderDot = styled.div`
  background-color: ${theme.palette.middleGrey};
  border-radius: 24.5px;
  width: 12px;
  height: 12px;
  cursor: pointer;

  .slick-active & {
    background-color: ${theme.palette.vividBlue};
  }
`

const useStyles = makeStyles(theme => ({
  modalContainer: {
    width: '100%',
    margin: '0 auto',

    '& .slick-prev, & .slick-next': {
      display: 'none !important'
    },
  },
  modalOverlay: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  modalInner: {
    width: '100%',
    display: 'inline-block',
    position: 'relative',
    maxWidth: 1400,
  },
  modalClose: {
    top: -40,
    right: 20,
    position: 'absolute',

    [theme.breakpoints.up('md')]: {
      top: 20,
      left: 'auto'
    }
  }
}));

const FeaturesGallery = ({
  anchorId,
  background,
  layout,
  pretitle,
  title,
  link,
  data
}) => {
  const [modal, openModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const sliderRef = useRef(null);

  const handleItemClick = (index) => {
    // openModal(true);
    // setModalIndex(index);
  }

  const desktopView = useMediaQuery(theme.breakpoints.up('md'));
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));

  const classes = useStyles();

  const filteredData = desktopView ? data && data.length > 0 && layout == '3' ? chunk(data, 3) : layout == '6' ? chunk(data, 6) : layout == '9' ? chunk(data, 9) : [] : chunk(data, 3);

  console.log('test filtered data',filteredData);
  console.log('layout', layout);

  var settings = {
    customPaging: function (i) {
      return (
        <SliderDot />
      );
    },
    dots: true,
    arrows: false,
    infinite: true,
    fade: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    centerPadding: '10px',
    // responsive: [
    //   {
    //     breakpoint: theme.breakpoints.width('md'),
    //     settings: {
    //       slidesToShow: items.length > 2 ? 3 : items.length
    //     }
    //   }
    // ]
  };
  

  return (
    <Wrapper backgroundColor={background} id={anchorId}>
      <Modal
        isOpen={modal}
        onClose={() => openModal(false)}
        overlayClassname={classes.modalOverlay}
        innerClassname={classes.modalInner}
        closeClassname={classes.modalClose}
      >
        <div className={classes.modalContainer}>
          <Slider
            forwardedRef={sliderRef}
            onInit={() => {
              setTimeout(() => { sliderRef.current.slickGoTo(modalIndex) }, 0)
            }}
            ref={(slider) => { sliderRef.current = slider }}
            settings={{
              initialSlide: modalIndex,
              adaptiveHeight: true
            }}
          >
            {filteredData.map((item, i) => {
              return (
                item.map((child, index) => {
                  return (
                    <div key={child.id || (i + index)}>
                      <GalleryOverlay
                        {...child}
                        imgCover={true}
                        autoWidth={true}
                      />
                    </div>

                  )
                })
              )
            })
            }
          </Slider>
        </div>
      </Modal>

      {pretitle &&
        <Box px={2}>
          <Text variant="subTitle" colour="vividBlue" uppercase={true} align="center">{pretitle}</Text>
        </Box>
      }
      {title &&
        <Box px={2}>
          <Text variant="h3" weight={800} uppercase={true} align="center">{title}</Text>
        </Box>
      }
      <Container>
        <Slider
          {...settings}
        >
          {filteredData &&
            filteredData.map(function (item, i) {
              return (
                <SliderItem key={i} layout={layout && layout}>
                  {

                    // Desktop View Start

                    // Layout 6 Start Desktop
                    layout == '6' ?
                      <>
                        {item && item[0] &&
                          <ImageRowContainer layout={layout && layout}>

                            <ImageContainer
                              //href={'#'}
                              // onClick={(e) => {
                              //   e.preventDefault()
                              //   handleItemClick((parseInt(layout) * i) + 0)
                              // }
                              // }
                            >
                            <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[0].title}</span></Text>
                              <RespImg
                                {...item[0].image}
                              />
                            </ImageContainer>

                          </ImageRowContainer>
                        }
                        {item && item.length > 0 &&
                          <ImageRowContainer layout={layout && layout}>
                            {item.map((child, index) => {
                              return (
                                index != 0 && (index == 1 || index == 2 || index == 3 || index == 4) &&
                                <ImageContainer
                                  key={index}
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + index)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{child.title}</span></Text>
                                  <RespImg
                                    {...child.image}
                                  />
                                </ImageContainer>
                              )
                            })}
                          </ImageRowContainer>
                        }
                        {item[5] &&
                          <ImageRowContainer layout={layout && layout}>

                            <ImageContainer
                              // href={'#'}
                              // onClick={(e) => {
                              //   e.preventDefault()
                              //   handleItemClick((parseInt(layout) * i) + 5)
                              // }
                              // }
                            >
                            <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[(item.length) - 1].title}</span></Text>
                              <RespImg
                                {...item[(item.length) - 1].image}
                              />
                            </ImageContainer>

                          </ImageRowContainer>
                        }
                      </>
                      // Layout 6 End Desktop

                      // Layout 9 Start Desktop 
                      : layout == '9' ?
                        <>
                          {item && item.length > 0 &&
                            <ImageRowContainer layout={layout && layout}>
                              {item && item[0] &&
                                <ImageContainer
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + 0)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[0].title}</span></Text>
                                  <RespImg
                                    {...item[0].image}
                                  />
                                </ImageContainer>
                              }
                              {item && item[1] &&
                                <ImageContainer
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + 1)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[1].title}</span></Text>
                                  <RespImg
                                    {...item[1].image}
                                  />
                                </ImageContainer>
                              }
                              {item && item[2] &&
                                <ImageContainer
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + 2)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[2].title}</span></Text>
                                  <RespImg
                                    {...item[2].image}
                                  />
                                </ImageContainer>
                              }

                            </ImageRowContainer>
                          }
                          {item && item.length > 2 &&
                            <ImageRowContainer layout={layout && layout}>
                              {item.map((child, index) => {
                                return (
                                  index > 2 && (index == 3 || index == 4 || index == 5) &&
                                  <ImageContainer
                                    // key={index}
                                    // href={'#'}
                                    // onClick={(e) => {
                                    //   e.preventDefault()
                                    //   handleItemClick((parseInt(layout) * i) + index)
                                    // }
                                    // }
                                  >
                                  <Text variant="h4" colour="white" uppercase={true} align="right"><span>{child.title}</span></Text>
                                    <RespImg
                                      {...child.image}
                                    />
                                  </ImageContainer>
                                )
                              })}
                            </ImageRowContainer>
                          }
                          {item && item.length > 5 &&
                            <ImageRowContainer layout={layout && layout}>
                              {item[6] &&
                                <ImageContainer
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + 6)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[(item.length) - 3].title}</span></Text>
                                  <RespImg
                                    {...item[(item.length) - 3].image}
                                  />
                                </ImageContainer>
                              }
                              {item[7] &&
                                <ImageContainer
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + 7)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[(item.length) - 2].title}</span></Text>
                                  <RespImg
                                    {...item[(item.length) - 2].image}
                                  />
                                </ImageContainer>
                              }
                              {item[8] &&
                                <ImageContainer
                                  // href={'#'}
                                  // onClick={(e) => {
                                  //   e.preventDefault()
                                  //   handleItemClick((parseInt(layout) * i) + 8)
                                  // }
                                  // }
                                >
                                <Text variant="h4" colour="white" uppercase={true} align="right"><span>{item[(item.length) - 1].title}</span></Text>
                                  <RespImg
                                    {...item[(item.length) - 1].image}
                                  />
                                </ImageContainer>


                              }
                            </ImageRowContainer>
                          }
                        </>

                        :

                        // Layout 3 Start Desktop
                        <ImageRowContainer layout={layout && layout}>
                          {item.map(function (child, index) {
                            return (
                              <ImageContainer
                                // key={index}
                                // href={'#'}
                                // onClick={(e) => {
                                //   e.preventDefault()
                                //   handleItemClick((parseInt(layout) * i) + index)
                                // }
                                // }
                              >
                              <Text variant="h4" colour="white" uppercase={true} align="right"><span>{child.title}</span></Text>
                                <RespImg
                                  {...child.image}
                                />
                              </ImageContainer>
                            )
                          })}
                        </ImageRowContainer>
                    // Layout 3 End Desktop

                    // Desktop View End

                    //:

                    // Mobile View Start
                    // <ImageRowContainer>
                    //   {item.map(function (child, index) {
                    //     return (
                    //       <ImageContainer
                    //         // key={index}
                    //         // href={'#'}
                    //         // onClick={(e) => {
                    //         //   e.preventDefault()
                    //         //   handleItemClick((parseInt(layout) * i) + index)
                    //         // }
                    //         // }
                    //       >
                    //       <Text variant="h4" colour="white" uppercase={true} align="right"><span>{child.title}</span></Text>
                    //         <RespImg
                    //           {...child.image}
                    //         />
                    //       </ImageContainer>
                    //     )
                    //   })}
                    // </ImageRowContainer>
                    // Mobile View End

                    }
                </SliderItem>
              )
            })
          }
        </Slider>
      </Container>
      {(link && link.title) &&
        <CTAContainer>
          <Box px={2}>
            <Cta primary href={link.href || '#'}>
              {link.title}
            </Cta>
          </Box>
        </CTAContainer>
      }

    </Wrapper>
  )
}

FeaturesGallery.propTypes = {
  anchorId: propTypes.string,
  background: propTypes.string,
  layout: propTypes.string,
  pretitle: propTypes.string,
  title: propTypes.string,
  link: propTypes.object,
  data: propTypes.array
}

FeaturesGallery.defaultProps = {
  anchorId: null,
  background: null,
  layout: null,
  pretitle: null,
  title: null,
  link: null,
  data: []
}

export default FeaturesGallery